import ConfirmDeleteModalUI from '@/components/common/ConfirmDeleteModalUI/ConfirmDeleteModalUI'
import { debounce } from 'lodash'
import { useConfigUI } from '../../context'
import { useDeleteStation } from '../../hooks/station'
import useTranslation from '@/hooks/useTranslation'

interface DeleteModalProps {
  id?: string
  interfaceId?: string
  onSuccess?: () => void
  name?: string
}

const DeleteStationModal = ({
  id,
  interfaceId,
  onSuccess,
  name,
}: DeleteModalProps) => {
  const { t } = useTranslation()
  const { closeModal } = useConfigUI()

  const { mutate: deleteModal, isLoading: loadingDeleteStation } =
    useDeleteStation()

  const handleDeleteSite = debounce(async () => {
    if (!id) return
    if (!interfaceId) return
    deleteModal({ interfaceId, id }, { onSuccess: () => onSuccess?.() })
  }, 300)

  return (
    <ConfirmDeleteModalUI
      title={t('DeleteStation')}
      name={name}
      text={t('stationDeleteConfirmation')}
      onClose={closeModal}
      onConfirm={handleDeleteSite}
      isLoading={loadingDeleteStation}
    />
  )
}

export default DeleteStationModal
